import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';

export type ForvalterLinkKind = 'generalforsamling' | 'okonomi' | 'hms' | 'other';

/** A configurable forvalter link-out card (V1.12) — categorised, named, individually toggleable. */
export interface ForvalterLinkCard {
  kind: string;
  label: string;
  url: string;
  forvalterName?: string | null;
  enabled: boolean;
}

/**
 * Phase V1.12 — forvalter link-out cards. The app links out to the forvalter's system for the heavy
 * regulated work (generalforsamling/økonomi/HMS) and never reimplements it. Residents/board read the
 * enabled cards; the lagadmin reads the full set and replaces it (URLs validated server-side). The
 * client never sends tenant/role — the read is tenant-scoped + the write is lagadmin-only server-side.
 */
@Injectable({ providedIn: 'root' })
export class ForvalterLinksService {
  private readonly http = inject(HttpClient);

  /** Enabled cards for the current tenant (resident/board surface). */
  enabled(): Observable<ForvalterLinkCard[]> {
    return this.http.get<ForvalterLinkCard[]>('/api/forvalter-links');
  }

  /** Every card incl. disabled (the lagadmin editor surface). */
  all(): Observable<ForvalterLinkCard[]> {
    return this.http.get<ForvalterLinkCard[]>('/api/forvalter-links/all');
  }

  /** Replace the tenant's link set (lagadmin). */
  save(links: ForvalterLinkCard[]): Observable<void> {
    return this.http.put<void>('/api/forvalter-links', { links });
  }
}
